/**
 * @author      Vadim Pr!de
 * @date        06.04.2018 03:59
 * @version     v1
 * @description
 */

var $helpers$ = $helpers$ || {};

window.__actionThisTabs_ = true;
window.addEventListener("focus", function() { window.__actionThisTabs_ = true; }, true);
window.addEventListener("blur", function() { window.__actionThisTabs_ = false; }, true);

$helpers$.isActiveTab = function() { return !!window.__actionThisTabs_; };

$helpers$.isNan = $helpers$.isNan || function(val){ return typeof val === 'number' && val !== val;};

$helpers$.isObject = $helpers$.isObject || function(data){ return typeof(data) === 'object' && data !== null; };

$helpers$.isArray = $helpers$.isArray || function(data){ return typeof(data) === 'object' && Array.isArray(data); };

$helpers$.isBoolean = $helpers$.isBoolean || function(data){ return typeof(data) === 'boolean'; };

$helpers$.isFunction = $helpers$.isFunction || function(data){ return typeof(data) === 'function'; };

$helpers$.isString = $helpers$.isString || function(data){ return typeof(data) === 'string'; };

$helpers$.isNull = $helpers$.isNull || function(data){ return data === null; };

$helpers$.isUndefined = $helpers$.isUndefined || function(data){ return typeof(data) === 'undefined'; };

$helpers$.isFinite = $helpers$.isFinite || isFinite;

$helpers$.isNumber = $helpers$.isNumber || function(data){ return typeof(data) === 'number'; };

$helpers$.isInt = $helpers$.isInt || function(data){ return Number.isInteger ? Number.isInteger(data) : $helpers$.isNumber(data) && !$helpers$.isNan(data) && $helpers$.isFinite(data) && !(data % 1);};

$helpers$.isFloat = $helpers$.isFloat || function(data){ return $helpers$.isNumber(data) && !$helpers$.isNan(data) && String(data).indexOf('.') !== -1; };

$helpers$.isEmpty = $helpers$.isEmpty || function(data){ if($helpers$.isUndefined(data) || $helpers$.isNan(data)){ return true; }else if($helpers$.isBoolean(data)){ return data !== true; }else if($helpers$.isObject(data)){return Object.keys(data).length < 1;}else{ return String(data).length < 1;}};

$helpers$.inObject = $helpers$.inObject || function(array, value){if(($helpers$.isString(value) || $helpers$.isNumber(value)) && $helpers$.isObject(array)){for(var key in array){if(array[key] === value){return key;}}}return false;};

$helpers$.inArray = $helpers$.inArray || function(value, array){return $helpers$.isArray(array) ? array.indexOf(value) !== -1 : false;};


// COOKIE --------------------------------------------------------------------------------------
$helpers$.cookie = $helpers$.cookie || {};
$helpers$.cookie.get = $helpers$.cookie.get || function(name) {
  var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
  return matches && matches[1]? decodeURIComponent(matches[1]) : undefined;
};
$helpers$.cookie.set = $helpers$.cookie.set || function(name, value, options) {
  options = options || {};
  var expires = options.expires;
  if (typeof expires === "number" && expires) {
    var d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }
  if (expires && expires.toUTCString){
    options.expires = expires.toUTCString();
  }
  value = encodeURIComponent(value);
  var updatedCookie = name + "=" + value + "; path=/";
  for (var propName in options) {
    updatedCookie += "; " + propName;
    var propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += "=" + propValue;
    }
  }
  document.cookie = updatedCookie;
};
// /COOKIE --------------------------------------------------------------------------------------

// LOCAL_STORAGE --------------------------------------------------------------------------------
$helpers$.localStorage = $helpers$.localStorage  || window.localStorage || new (function (){
  var __tmp = {};

  /**
   *
   * @param key
   * @returns {*}
   */
  this.getItem = function (key){
      if($helpers$.isUndefined(key)){
        throw new Error('Failed to execute \'getItem\' on \'Storage\': 1 argument required, but only 0 present.')
      }
      return __tmp[String(key)];
    }

  /**
   *
   * @param key
   * @param value
   * @returns {string}
   */
  this.setItem = function (key, value){
      if($helpers$.isUndefined(key) || $helpers$.isUndefined(value)){
        throw new Error('Failed to execute \'setItem\' on \'Storage\': 2 argument required, but only '+ ($helpers$.isUndefined(key) ? 0 : 1) +' present.')
      }
      return __tmp[String(key)] = String(value);
    }

  /**
   *
   * @param key
   * @returns {*}
   */
  this.removeItem = function (key){
      if($helpers$.isUndefined(key)){
        throw new Error('Failed to execute \'setItem\' on \'Storage\': 2 argument required, but only 0 present.')
      }
      key = String(key);
      delete __tmp[key];
      return this.getItem(key);
    }

  /**
   *
   * @returns {{}}
   */
  this.clear = function (){
    return __tmp = {};
  }

})();
// /LOCAL_STORAGE -------------------------------------------------------------------------------

$helpers$.EventEmitter = $helpers$.EventEmitter || function() {
  var $this = this;
  var __listerens = {};
  var __incListeren = 0;
  var __maxListeners = 10;
  var __prefix_once = '_once';


  /**
   * Append EE listeren
   * @param name
   * @param callback
   * @param once
   * @return {EventEmitter}
   */
  this.on = function(name, callback, once) {
    if(!$helpers$.isString(name) || !$helpers$.isFunction(callback)){
      return $this;
    }
    ++__incListeren;

    var i = String(String(__incListeren) + (once === true ? __prefix_once : ''));
    if(!$helpers$.isObject(__listerens[name])){
      __listerens[name] = {};
    }
    __listerens[name][i] = callback;
    if($this.listenerCount(name) > __maxListeners){
      console.warn('EE ', name, ', exceeded maxListeners : ', __maxListeners + '/' + $this.listenerCount(name), '. Use EE.setMaxListeners(n)!');
    }
    return $this;
  };

  /**
   * Apend once EE listeren
   * @param name
   * @param callback
   * @return {EventEmitter}
   */
  this.once = function(name, callback){
    return $this.on(name, callback, true);
  };

  /**
   * Getter all listeren name
   * @returns {string[]}
   */
  this.getListerensName = function(){
    return Object.keys(__listerens);
  };

  /**
   * Clear all listeren
   * @returns {{}}
   */
  this.clearAllListerens = function(){
    var listerens = $this.getListerensName();
    for(var i in listerens){
      $this.offAll(listerens[i]);
    }
    return __listerens;
  };

  /**
   * Getter count Event listeren
   * @param name
   * @returns {number}
   */
  this.listenerCount = function(name){
    var count = 0;
    if(!$helpers$.isString(name) || !$helpers$.isObject(__listerens[name])){
      return count;
    }
    return Object.keys(__listerens[name]).length;
  };

  /**
   * Set max listeners
   * @param count
   * @returns {boolean}
   */
  this.setMaxListeners = function(count){
    if(!$helpers$.isInt(count)){
      return false;
    }
    __maxListeners = parseInt(count);
    return true;
  };

  /**
   * Delete EventEmitter listeren
   * @param name
   * @param callback
   * @return {EventEmitter}
   */
  this.off = function(name, callback){
    if(!$helpers$.isString(name) || !$helpers$.isFunction(callback) || !$helpers$.isObject(__listerens[name])){
      return $this;
    }
    for(var i in __listerens[name]){
      if(__listerens[name][i] === callback){
        delete __listerens[name][i];
      }
    }
    if(Object.keys(__listerens[name]).length === 0){
      delete __listerens[name];
    }
    return $this;
  };

  /**
   * Delete all EventEmitter listeren
   * @param name
   * @return {EventEmitter}
   */
  this.offAll = function(name){
    if(!$helpers$.isObject(__listerens[name])){
      return $this;
    }
    for(var i in __listerens[name]){
      delete __listerens[name][i];
    }
    delete __listerens[name];
    return $this;
  };

  /**
   * Emit EE listeren
   * @param name
   * @param data_1
   * @param data_2
   * @param data_3
   * @param data_4
   * @param data_5
   * @return {EventEmitter}
   */
  this.emit = function(name, data_1, data_2, data_3, data_4, data_5){
    if(!$helpers$.isString(name) || !$helpers$.isObject(__listerens[name])){
      return $this;
    }
    for(var i in __listerens[name]){
      if($helpers$.isFunction(__listerens[name][i])){
          __listerens[name][i].call(this, data_1, data_2, data_3, data_4, data_5);
        if(i.indexOf(__prefix_once) >= 0){
          $this.off(name, __listerens[name][i]);
        }
      }
    }
    return $this;
  };
};


/**
 * Convert url images to Base64
 * @param src
 * @return {Promise}
 */
$helpers$.imagesToBase64 = $helpers$.imagesToBase64 || function(src) {
  return new Promise(function(resolve, reject) {
    if(!$helpers$.isString(src) || $helpers$.isEmpty(src)){
      return reject('Invalid src');
    }
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function() {
      var canvas = document.createElement('CANVAS');
      var ctx = canvas.getContext('2d');
      canvas.height = this.naturalHeight;
      canvas.width = this.naturalWidth;
      ctx.drawImage(this, 0, 0);
      resolve(canvas.toDataURL());
    };
    img.onerror = function() {
        reject('Not Image')
    };
    img.src = src;
    if (img.complete || $helpers$.isUndefined(img.complete)) {
      img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
      img.src = src;
    }
  });
};


$helpers$.base64 = $helpers$.base64 || {};

/**
 *
 * @param base64
 * @return {boolean}
 */

$helpers$.base64.getType = $helpers$.base64.getType || function(base64){
  if(!$helpers$.isString(base64)) return false;
  var mat = base64.match(/^data:([^;]+);/);
  return mat && mat[1] ? mat[1] : false;
};

/**
 *
 * @param base64
 * @return {*}
 */
$helpers$.base64.getBase64 = $helpers$.base64.getBase64 || function(base64){
  if(!$helpers$.isString(base64)) return false;
  return base64.replace(/^data:([^,]+),/, '');
};

/**
 *
 * @param base64
 * @return {boolean}
 */
$helpers$.base64.getExt = $helpers$.base64.getExt || function(base64){
  var m = base64.match(/^data:image\/([^,]+);/);
  return m && m[1] ? m[1] : false;
};

/**
 * Convert base64 images to blob
 * @param base64
 * @param chunkSize
 * @return {*}
 */
$helpers$.base64.toBlob = $helpers$.base64.toBlob || function(base64, chunkSize) {
  chunkSize = chunkSize || 512;
  if(!$helpers$.isString(base64)) return false;
  var b64 = $helpers$.base64.getBase64(base64);
  var bytes = atob(b64);
  var arr = [];
  for (var offset = 0; offset < bytes.length; offset += chunkSize) {
    var slice = bytes.slice(offset, offset + chunkSize);
    var n = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) { n[i] = slice.charCodeAt(i);}
    arr.push(new Uint8Array(n));
  }
  return new Blob(arr, {'type': $helpers$.base64.getType(base64)});
};

/**
 *
 * @param data
 * @return {*|boolean}
 */
$helpers$.isXDataInput = function(data) {
  return $helpers$.isObject(data) &&
    $helpers$.isString(data['ID']) &&
    $helpers$.isString(data['method']) &&
    $helpers$.isInt(data['status']) &&
    $helpers$.isString(data['appName']) &&
    $helpers$.isObject(data['data']) &&
    $helpers$.isInt(data['timeCreate']) &&
    $helpers$.isInt(data['timeoutDestroy']);
};


/**
 *
 * @param value
 * @return {*}
 */
$helpers$.json_encode = function(value){
  try{
    return JSON.stringify(value);
  }catch(e){
    return false;
  }
};

/**
 *
 * @param value
 * @return {*}
 */
$helpers$.json_decode = function(value){
  try{
    return JSON.parse(value);
  }catch(e){
    return false;
  }
};

/**
 *
 * @return {string}
 */
$helpers$.uuid = function(){
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c,r){return ('x'== c ? ( r = Math.random()*16|0) : (r&0x3|0x8)).toString(16);});
};

/**
 *
 * @param val
 * @return {string}
 */
$helpers$.getContructorName = function(val){
  return $helpers$.isObject(val) && $helpers$.isFunction(val.constructor) && $helpers$.isString(val.constructor.name) ? val.constructor.name : '';
};


/**
 *
 * @param src
 * @return {Promise}
 */
$helpers$.includeScript = function(src) {
  return new Promise(function(resolve, reject) {
    var el;
    if(document.querySelector){
      el = document.querySelector('script[src="'+src+'"]');
      if(el) return resolve(el);
    }
    el = document.createElement('script');
    el.id = $helpers$.uuid();
    el.onload = function() {
      resolve(el);
    };
    el.onerror = function(e) {
      reject(e);
      try{ el.remove(); }catch (e) {}
    };
    el.type = 'text/javascript';
    el.src = src || '';
    document.getElementsByTagName('head')[0].appendChild(el);
  });
};

/**
 *
 * @param src
 * @return {Promise}
 */
$helpers$.includeStyle = function(src) {
  return new Promise(function(resolve, reject) {
    var el;
    if(document.querySelector){
      el = document.querySelector('link[href="'+src+'"]');
      if(el) return resolve(el);
    }
    el = document.createElement('link');
    el.id = $helpers$.uuid();
    el.onload = function() { resolve(el); };
    el.onerror = function(e) { reject(e); try{ el.remove(); }catch (e) {} };
    el.rel = 'stylesheet';
    el.type = 'text/css';
    el.href = src;
    document.getElementsByTagName('head')[0].appendChild(el);
  });
};

if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }
    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}

window.sound = window.sound || {};

/**
 *
 * @param audio_href
 * @returns {HTMLAudioElement}
 */
$helpers$.getSound = function(audio_href) {
  if(!window.sound[audio_href]){
    window.sound[audio_href] = new Audio(audio_href);
    window.sound[audio_href].preload = 'auto';
    window.sound[audio_href].loopCount = 0;
  }
  return window.sound[audio_href];
};

/**
 *
 * @param audio
 */
$helpers$.releaseSoundLoop = function(audio) {
  audio.loopCount = Math.max(0, audio.loopCount - 1);
  if(audio.loopCount){
    return;
  }
  audio.loop = false;
  audio.pause();
  audio.currentTime = 0;
};

/**
 *
 * @param audioHrefList
 */
$helpers$.unlockSoundList = function(audioHrefList) {
  audioHrefList.forEach(function(audio_href) {
    var audio = $helpers$.getSound(audio_href);
    if(audio.isUnlock || !audio.paused){
      return;
    }
    audio.volume = 0.01;
    var play = audio.play();
    if(!play || typeof play.then !== 'function'){
      audio.volume = 1;
      return;
    }
    play.then(function() {
      audio.isUnlock = true;
      if(!audio.loopCount){
        audio.pause();
        audio.currentTime = 0;
      }
      audio.volume = 1;
    })['catch'](function() {
      audio.volume = 1;
    });
  });
};

/**
 *
 * @param audio_href
 * @param hash
 */
$helpers$.playSound = function(audio_href, hash) {
  if(!$helpers$.isString(audio_href) || $helpers$.isEmpty(audio_href)) return;
  hash = String(hash)+String(audio_href);
  var _play = function(){
    try{
      var audio = $helpers$.getSound(audio_href);
      audio.currentTime = 0;
      var play = audio.play();
      if(play && typeof play['catch'] === 'function'){
        play['catch'](function() {});
      }
    }catch (e) {}
  };
  setTimeout(function() {
    if($helpers$.cookie.get(hash)) return;
    $helpers$.cookie.set(hash, 1, {'expires' : 3});
    _play();
  }, Math.round(0.5 + Math.random() * 200));
};

/**
 *
 * @returns {Promise}
 */
$helpers$.testSound = function(){
  if($helpers$.testSoundPromise){
    return $helpers$.testSoundPromise;
  }
  $helpers$.testSoundPromise = new Promise(function(resolve, reject) {
    var eventList = ['mousedown', 'keydown', 'touchend'];
    var isPlaying = false;
    var el = null;
    var el_close = null;
    var el_button_deny = null;
    var finish = function() {
      if(el){
        el.remove();
      }
      eventList.forEach(function(eventName) {
        window.removeEventListener(eventName, play, true);
      });
    };
    var deny_handler = function() {
      finish();
      reject('deny');
    };
    var show = function() {
      if(el){
        return;
      }
      el = document.createElement('div');
      el.id = 'testSound';
      el.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); z-index: 99999;";
      var el_box = document.createElement('div');
      el_box.style = "position: absolute; top: 0; right: 5%; background: #fff; padding: 17px 30px; font: normal 14px sans-serif; border: 1px solid; border-radius: 5px; text-align: right;";
      el_close = document.createElement('div');
      el_close.style = "position: absolute; color: #000; right: 10px; font: normal 18px monospace; top: 10px; cursor: pointer;";
      el_close.innerText = "x";
      var el_h1 = document.createElement('h1');
      el_h1.style = "font: normal 18px sans-serif; margin: 10px 0; padding: 0; text-align: left;";
      el_h1.innerText = "...requests permission to:";
      var el_info = document.createElement('div');
      el_info.style = "padding: 0 0 15px 25px; text-align: left;";
      el_info.innerText = "Play audio";
      el_button_deny = document.createElement('button');
      el_button_deny.style = "margin: 0 3px; padding: 8px 12px; background: #fff; border: 1px solid #d8d8d8; border-radius: 5px; color: #4292f5; font-weight: 800;";
      el_button_deny.innerText = "Block";
      var el_button_allow = el_button_deny.cloneNode();
      el_button_allow.innerText = "Allow";
      el.appendChild(el_box);
      el_box.appendChild(el_close);
      el_box.appendChild(el_h1);
      el_box.appendChild(el_info);
      el_box.appendChild(el_button_deny);
      el_box.appendChild(el_button_allow);
      document.body.appendChild(el);
      el_close.onclick = deny_handler;
      el_button_deny.onclick = deny_handler;
    };
    var play = function(e) {
      if(e && el && (e.target === el_close || e.target === el_button_deny)){
        return;
      }
      $helpers$.unlockSoundList(['/request.mp3', '/message.mp3']);
      if(isPlaying){
        return;
      }
      isPlaying = true;
      var audio = new Audio('/testSound.mp3?v4');
      audio.volume = 0.5;
      var playPromise = audio.play();
      if(!playPromise || typeof playPromise.then !== 'function'){
        finish();
        return resolve(audio);
      }
      playPromise.then(function() {
        finish();
        resolve(audio);
      })['catch'](function() {
        isPlaying = false;
        show();
      });
    };
    eventList.forEach(function(eventName) {
      window.addEventListener(eventName, play, true);
    });
    play();
  });
  return $helpers$.testSoundPromise;
};

/* Title */
$helpers$.title = {};
$helpers$.title.get = function(){
  return document.title || '';
};
$helpers$.title.set = function(text){
  try{
    document.title = text;
    return true;
  }catch (e) {}
  return false
};
$helpers$.title.original = $helpers$.title.get();
$helpers$.title.getOriginal = function(){
  return $helpers$.title.original;
};
$helpers$.title._animationTitleHandler_ = false;
$helpers$.title.setAnimation = function(action, text, time) {
  try{
    if($helpers$.title._animationTitleHandler_){
      clearInterval($helpers$.title._animationTitleHandler_);
      $helpers$.title._animationTitleHandler_ = false;
      $helpers$.title.set($helpers$.title.getOriginal());
    }
    if(action){
      time = $helpers$.isInt(time) ? time : 1000;
      $helpers$.title._animationTitleHandler_ = setInterval(function(text) {
          $helpers$.title.set($helpers$.title.get() === $helpers$.title.getOriginal() ? text : $helpers$.title.getOriginal());
      }, time, String(text));
    }
    return true;
  }catch (e) {}
  return false;
};

$helpers$.getGetParams = function(){
  return window
    .location
    .search
    .replace('?','')
    .split('&')
    .reduce(
      function(p,e){
        var a = e.split('=');
        p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
        return p;
      },
      {}
    ) || {};
};

/**
 *
 * @param val
 * @param def
 * @returns {*}
 */
$helpers$.getVal = function(val, def) {
  return $helpers$.getGetParams()[val] || def;
};

/**
 *
 * @param __top
 * @param __bottom
 * @param __selector
 * @param __attribute
 */
$helpers$.preloadImage = function(__top, __bottom, __selector, __attribute) {

  var $this = this;
  var __left = 30;
  var __right = 30;
  
  /**
   *
   * @param el
   * @returns {boolean}
   */
  this.isVisible = function(el) {
    if(!(el instanceof Node)) return false;
    if(!el.getBoundingClientRect) return true;
    var elSize = el.getBoundingClientRect ? el.getBoundingClientRect() : {};
    elSize['top'] = elSize['top'] || 0;
    elSize['left'] = elSize['left'] || 0;
    var heightParent = parseInt(el.getAttribute('data-parent-height') ?  el.parentNode.clientHeight : 0);
    var widthParent = parseInt(el.getAttribute('data-parent-width') ?  el.parentNode.clientWidth : 0);
    var heightVisible = (elSize['top'] + __top) >= 0 && (elSize['top']  - window.innerHeight - heightParent + __bottom) <= 0;
    var widthVisible = (elSize['left'] + __left) >= 0 && (elSize['left']  - window.innerWidth - widthParent + __right) <= 0;
    return heightVisible && widthVisible;
  };

  /**
   *
   * @param el
   */
  this.updateEl = function(el) {
    if(el instanceof Node){
      var REPLACE_ATTR = 'data-replaceimg';
      var attr = el.getAttribute(__attribute) || '';
      var replace = el.getAttribute(REPLACE_ATTR) || false;
      if(!attr.length) return false;
      if(el.nodeName === 'IMG'){
        if(el.getAttribute('src') !== attr && this.isVisible(el)){
          el.src = attr;
        }
      }else if(replace && this.isVisible(el)){
        var img = document.createElement('img');
        if(el.attributes){
          for(var i in el.attributes){
            if(typeof el.attributes[i] === 'object' && el.attributes[i].name && el.attributes[i].name !== REPLACE_ATTR){
              img.setAttribute(el.attributes[i].name, el.attributes[i].value);
            }
          }
        }
        img.src = attr;
        el.parentNode.replaceChild(img,el);
      }else{
        var styles = window.getComputedStyle ? window.getComputedStyle(el) : {};
        if(styles['backgroundImage'] !== attr && this.isVisible(el)){
          el.style.backgroundImage = 'url('+attr+')';
        }
      }
    }
  };

  /**
   *
   */
  this.update = function() {
    var els = document.querySelectorAll ? document.querySelectorAll(__selector) : [];
    for(var i in els){
      this.updateEl(els[i]);
    }
  };

  /**
   *
   */
  (function() {
    __top      = typeof __top === 'number' && __top === __top ? __top : 30;
    __bottom   = typeof __bottom === 'number' && __bottom === __bottom ? __bottom : 30;
    __selector = typeof __selector === 'string' && __selector.length ? __selector : '.preloadImage';
    __attribute = typeof __attribute === 'string' && __attribute.length ? __attribute : 'data-pli';
    window.addEventListener('scroll', function() {
      $this.update();
    });
    window.addEventListener("resize", function() {
      $this.update();
    });
  })();
};

/* end: Title */

/**
 *
 * @param object
 * @param iterationFunc
 * @param async
 * @returns {Promise}
 */
$helpers$.forEach = function(object, iterationFunc, async){
  async = !!async;
  if(!$helpers$.isObject(object)) throw new Error('object is not object');
  if(!$helpers$.isFunction(iterationFunc)) throw new Error('iterationFunc is not function');

  var keyList = Object.keys(object);
  var data = {
    'iterations' : 0,
    'lastKey' : undefined,
    'keyList' : Object.assign([], keyList),
    'isStop' : false,
    'async' : async
  };
  var prom = new Promise(function(resolve, reject) {
    var next = function(){
      iteration();
      return true;
    };
    var stop = function(){
      if(data.isStop){
        return false;
      }
      data.isStop = true;
      resolve(data);
      return true;
    };
    var iteration = function() {
      return new Promise(function(resolveIteration) {
        var key = keyList.shift();
        if(!key || data.isStop){
          resolveIteration();
          return resolve(data);
        }
        data.iterations++;
        data.lastKey = key;
        if(!async){
          iterationFunc(key, object[key], stop, function() {});
          iteration();
        }else{
          iterationFunc(key, object[key], stop, next);
        }
      });
    }

    iteration()['catch'](reject);
  });
  prom['catch'](function(e) {
    console.error('forEach', e);
  });
  return prom;
};

/**
 *
 * @param url
 * @param data
 * @param headers
 * @returns {Promise<Object>}
 */
$helpers$.getAjax = function(url, data, headers) {
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", String(url || ''));
    xhr.setRequestHeader('HTTP_X_REQUESTED_WITH', 'xmlhttprequest');
    if(typeof headers === 'object'){
      for(var i in headers){
        xhr.setRequestHeader(i, headers[i]);
      }
    }
    xhr.onload = function() {
      if (xhr.status === 200) {
        var data = $helpers$.json_decode(xhr.response) || {};
        if(data.result !== 'ok'){
          return reject(new Error(data.text || data.error || 'Unknown error'));
        }
        resolve(data.data || data);
      } else {
        reject(new Error('Unknown response, HTTP code:' + xhr.status));
      }
    }
    xhr.onerror = function() {
      reject(new Error('There is a network error.'));
    }
    if(data instanceof FormData){

    }else if(typeof data === 'object'){
      var fData = new FormData();
      for(var i in data){
        fData.append(i, data[i]);
      }
      data = fData;
    }
    xhr.send(data);
  });
};

/**
 *
 * @param bytes
 * @param dec
 * @returns {string}
 */
$helpers$.formatFileSize = function (bytes, dec){
  bytes = parseFloat(bytes || '0');
  bytes = bytes < 0 || bytes !== bytes ? 0 : bytes;
  dec = Math.max(0, Math.min(100, parseInt(dec)  || 0));
  var d = 1024;
  var textTemp = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  var summ = bytes;
  var iTemp = 0;
  for(var i in textTemp){
    var s = summ > 0 ? summ / d : 0;
    if(s >= 1){
      iTemp = ++i;
      summ = s;
    }
  }
  if(!textTemp[iTemp])  iTemp = textTemp.length - 1;
  return (dec > 1 ? parseFloat(summ).toFixed(dec) : Math.floor(summ)) + ' ' + textTemp[iTemp];
};

/**
 *
 * @param __el
 * @param __dUp
 * @param __dDown
 */
$helpers$.scrollTrigger = function (__el, __dUp, __dDown){
  var $this = this;
  var __lastScrollTop = 0;
  var __lastScrollHeight = 0;
  var __lastHeightWidow = 0;
  var __lastHeightEl = 0;
  var __lastDirection = 0;
  var __directionUp = 0;
  var __directionDown = 0;
  var __blockUp = false;
  var __blockDown = false;

  var _run = function (fn){
    return new Promise(function (resolve, reject){
      if(typeof fn !== 'function') throw new Error('ErrorFunction');
      var init = fn();
      if(typeof init['then'] === 'function' && typeof init['catch'] === 'function'){
        return init.then(resolve)['catch'](reject);
      }
      return resolve(init);
    });
  };

  var _handler = function (){
    var scrollTop = __el.scrollTop || document.documentElement.scrollTop;
    var clientHeight = __el.clientHeight || document.documentElement.clientHeight;
    var scrollHeight = __el.scrollHeight || document.documentElement.scrollHeight;
    var windowHeight = window.innerHeight;
    if(
        __lastScrollTop === scrollTop &&
        __lastHeightEl === clientHeight &&
        __lastHeightWidow === windowHeight &&
        __lastScrollHeight === scrollHeight
    ){
      return;
    }
    var _direction = __lastScrollTop > scrollTop ? 1 :  (__lastScrollTop < scrollTop ? 2 : 0);
    __lastScrollTop = scrollTop;
    __lastScrollHeight = scrollHeight;
    __lastHeightEl = clientHeight;
    __lastHeightWidow = windowHeight;
    __lastDirection = _direction;
    if(_direction === 1){
      if(__lastScrollTop - __directionUp <= 0){
        if(__blockUp) return;
        __blockUp = true;
        _run($this.up)['finally'](function (){
          __blockUp = false;
        });
      }
      return;
    }
    if(_direction === 2){
      if(__lastScrollTop + __lastHeightEl + __directionDown >= __lastScrollHeight){
        if(__blockDown) return;
        __blockDown = true;
        _run($this.down)['finally'](function (){
          __blockDown = false;
        });
      }
      return;
    }
  };

  /**
   *
   * @returns {*}
   */
  this.down = function (){
    return new Promise(function (resolve){
      resolve();
    });
  };

  /**
   *
   * @returns {*}
   */
  this.up = function (){
    return new Promise(function (resolve){
      resolve();
    });
  };

  /**
   *
   * @param d
   * @returns {boolean}
   */
  this.setDirectionDown = function (d){
    if(typeof d !== "number" || d !== d) return false;
    __directionDown = d || 0;
    return true;
  };

  /**
   *
   * @param d
   * @returns {boolean}
   */
  this.setDirectionUp = function (d){
    if(typeof d !== "number" || d !== d) return false;
    __directionUp = d || 0;
    return true;
  };


  (function (){
    if(!(__el instanceof Node) && __el !== window){
      throw new Error('InvalidElement');
    }
    $this.setDirectionDown(__dDown);
    $this.setDirectionUp(__dUp);
    __el.addEventListener('scroll', function (){
      _handler();
    });
    window.addEventListener('resize', function (){
      _handler();
    });
  })();
};


/**
 *
 * @param oldObject
 * @param newObject
 * @param callback
 * @returns {*[]}
 */
$helpers$.diffObject = function (oldObject, newObject, callback){
  callback = typeof callback === 'function' ? callback : function(){};
  var diffArray = [];
  if(typeof oldObject !== 'object' || typeof newObject !== 'object') return diffArray;



  if(oldObject === newObject) return diffArray;
  var _emitCallback = function(key, oldObj, newObj){
    try{
      callback(key, oldObj, newObj);
    }catch (e){
      console.error('diffObjects', e);
    }
  };
  var _diffFn = function(obj1, obj2){
    var isArray = Array.isArray(obj1) && Array.isArray(obj1);
    for(var i in obj1){
      try{
        if(isArray){
          if(diffArray.indexOf(obj1[i]) === -1 && obj2.indexOf(obj1[i]) === -1){
            _emitCallback(i, obj1[i], undefined);
            diffArray.push(obj1[i]);
          }
          continue;
        }
        if(diffArray.indexOf(i) !== -1){
          continue;
        }
        // string, number, boolean
        if(obj1[i] === obj2[i]) continue;
        if(typeof obj1[i] !== typeof obj2[i]) {
          _emitCallback(i, oldObject[i], newObject[i]);
          diffArray.push(i);
          continue;
        }
        if(typeof obj1[i] === 'object' && JSON.stringify(obj1[i]) !== JSON.stringify(obj2[i])){
          _emitCallback(i, oldObject[i], newObject[i]);
          diffArray.push(i);
        }
      }catch (e){
        console.error('diffObjects->diffFn', e);
      }
    }
    return _diffFn;
  };
  _diffFn(newObject, oldObject);
  _diffFn(oldObject, newObject);
  return diffArray;
};
